export interface ManualSyncOutcome {
  created: number;
  updated: number;
  unassigned: number;
  errors: ReadonlyArray<unknown>;
}

export type AutomaticSyncBlockReason =
  | 'FIRST_SYNC_REQUIRED'
  | 'RECONNECT_CATCH_UP_REQUIRED'
  | null;

/** Mirrors the backend rule that establishes the first-manual-sync baseline. */
export function establishesInitialSync(outcome: ManualSyncOutcome): boolean {
  return (
    outcome.errors.length === 0 ||
    outcome.created > 0 ||
    outcome.updated > 0 ||
    outcome.unassigned > 0
  );
}

export function automaticSyncBlockReason(
  initialSyncCompleted: boolean,
  reconnectCatchUpRequired: boolean,
): AutomaticSyncBlockReason {
  if (!initialSyncCompleted) return 'FIRST_SYNC_REQUIRED';
  if (reconnectCatchUpRequired) return 'RECONNECT_CATCH_UP_REQUIRED';
  return null;
}
